import {
  Box,
  Button,
  InputBase,
  MenuItem,
  Stack,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import QuizIcon from "@mui/icons-material/Quiz";
import { getCategoryLabel } from "../constants/contentOptions";

export default function ContenidoFilters({
  categoryFilter,
  statusFilter,
  searchQuery,
  categoryOptions,
  statusOptions,
  onCategoryChange,
  onStatusChange,
  onSearchChange,
  onCreateContent,
  onCreateEvaluation,
}) {
  const statusLabels = {
    DRAFT: "Borrador",
    PUBLISHED: "Publicado",
    ARCHIVED: "Archivado",
  };

  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      spacing={2}
      sx={{ alignItems: { md: "center" }, justifyContent: "space-between" }}
    >
      <Stack direction="row" spacing={2} sx={{ alignItems: "center", flexWrap: "wrap" }}>
        <TextField
          select
          size="small"
          value={categoryFilter}
          onChange={onCategoryChange}
          SelectProps={{
            displayEmpty: true,
            renderValue: (value) => (value === "ALL" ? "Categoría" : getCategoryLabel(value)),
          }}
          sx={{
            minWidth: 180,
            bgcolor: "secondary.200",
            borderRadius: "999px",
            "& .MuiOutlinedInput-root": { borderRadius: "999px", color: "primary.900" },
            "& .MuiSvgIcon-root": { color: "primary.900" },
          }}
        >
          <MenuItem value="ALL">Todos</MenuItem>
          {categoryOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          select
          size="small"
          value={statusFilter}
          onChange={onStatusChange}
          SelectProps={{
            displayEmpty: true,
            renderValue: (value) =>
              value === "ALL" ? "Estado" : statusLabels[value] || value,
          }}
          sx={{
            minWidth: 160,
            bgcolor: "secondary.200",
            borderRadius: "999px",
            "& .MuiOutlinedInput-root": { borderRadius: "999px", color: "primary.900" },
            "& .MuiSvgIcon-root": { color: "primary.900" },
          }}
        >
          <MenuItem value="ALL">Todos</MenuItem>
          {statusOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {statusLabels[option] || option}
            </MenuItem>
          ))}
        </TextField>
      </Stack>

      <Stack direction="row" spacing={2} sx={{ alignItems: "center", flexWrap: "wrap" }}>
        <Box
          sx={{
            width: { xs: "100%", md: 260 },
            height: 36,
            px: 1.5,
            bgcolor: "secondary.200",
            borderRadius: "20px",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <SearchIcon sx={{ color: "primary.900", fontSize: 18 }} />
          <InputBase
            value={searchQuery}
            onChange={onSearchChange}
            placeholder="Buscar"
            sx={{ flex: 1, fontSize: 13, fontWeight: 700, color: "primary.900" }}
          />
        </Box>

        <Button
          startIcon={<AddIcon />}
          onClick={onCreateContent}
          sx={{
            bgcolor: "secondary.200",
            color: "primary.900",
            px: 2.5,
            py: 1,
            borderRadius: "24px",
            textTransform: "none",
            fontWeight: 700,
            fontSize: 14,
            "&:hover": { bgcolor: "secondary.300" },
          }}
        >
          Crear Contenido
        </Button>

        <Button
          startIcon={<QuizIcon />}
          onClick={onCreateEvaluation}
          sx={{
            bgcolor: "primary.500",
            color: "logoblanco",
            px: 2.5,
            py: 1,
            borderRadius: "24px",
            textTransform: "none",
            fontWeight: 700,
            fontSize: 14,
            "&:hover": { bgcolor: "primary.600" },
          }}
        >
          Crear Evaluación
        </Button>
      </Stack>
    </Stack>
  );
}